import { PropsWithChildren } from "react";
import { SidebarContext, SidebarContextValue } from "./context";

export const SidebarProvider = ({
  children,
  forceExpanded,
  setFlyoutPointerInside
}: PropsWithChildren<SidebarContextValue>) => {
  return (
    <SidebarContext.Provider value={{ forceExpanded, setFlyoutPointerInside }}>{children}</SidebarContext.Provider>
  );
};
